const FP_KEY = 'expai_device_fp';

function randomId(): string {
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}

/** Stable per-browser id sent as X-Device-Fingerprint (hashed server-side). */
export function getDeviceFingerprint(): string {
  let fp = localStorage.getItem(FP_KEY);
  if (!fp) {
    fp = randomId();
    localStorage.setItem(FP_KEY, fp);
  }
  return fp;
}
